import { render, staticRenderFns } from "./AllowanceBreakdownWrapper.vue?vue&type=template&id=30e8ed56"
import script from "./AllowanceBreakdownWrapper.vue?vue&type=script&lang=js"
export * from "./AllowanceBreakdownWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports